import React from 'react';

const About = () => {
  return (
    <div className="center">
      <h1>About Traveln</h1>
      <br />
      <p>Traveln helps you to search for an interesting places to explore. </p>
      <br />
      <p>Created with React, Leaflet.js and Open Weather & Foursquare APIs.</p>
      <br />
      <p>Version: 1.0.0</p>
    </div>
  );
};

export default About;
